<script>
  import InputContainer from '@components/inputs/input-container.svelte'
  import Button from '@components/buttons/button.svelte'
  import { Lock, Eye, EyeOff, TriangleAlert } from 'lucide-svelte'

  let { value = $bindable(""), ...inputProps } = $props()

  let inputType = $state('password')

</script>

<InputContainer bind:value type={inputType} {...inputProps}>
  {#snippet prefix()}
    <Lock size={14} class="text-gray-400" />
  {/snippet}

  {#snippet suffix()}
    <Button 
      variant="naked" 
      Icon={inputType === 'password' ? Eye : EyeOff} 
      onclick={() => inputType = inputType === 'password' ? 'text' : 'password'}
      tabIndex={-1} />
  {/snippet}
</InputContainer>
